export default function LoadingViewFile() {
    return (
        <div className="fixed inset-0 z-50 flex cursor-progress items-center justify-center bg-slate-950/40 p-4 backdrop-blur-[3px]">
            <div className="flex w-full max-w-[320px] flex-col items-center text-center">
                <div className="relative flex h-16 w-16 items-center justify-center">
                    <div className="absolute inset-0 animate-ping rounded-full bg-[#186cb2]/20" />
                    <div className="relative flex h-14 w-14 items-center justify-center rounded-full border border-[#186cb2]/30 bg-white shadow-lg">
                        <svg className="h-7 w-7 animate-[viewFile_1.5s_ease-in-out_infinite] text-[#186cb2]" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" >
                            <path d="M6 3H14L19 8V21H6V3Z" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
                            <path d="M14 3V8H19" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
                            <path d="M9 13H15" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
                            <path d="M9 17H15" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
                        </svg>
                    </div>
                </div>
                <p className="mt-3 text-sm font-semibold text-white drop-shadow-sm">
                    Opening file
                </p>
                <div className="mt-2 flex items-center justify-center gap-1">
                    <span className="h-1.5 w-1.5 animate-[viewDot_1.4s_ease-in-out_infinite] rounded-full bg-[#186cb2]" />
                    <span className="h-1.5 w-1.5 animate-[viewDot_1.4s_ease-in-out_0.2s_infinite] rounded-full bg-[#186cb2]" />
                    <span className="h-1.5 w-1.5 animate-[viewDot_1.4s_ease-in-out_0.4s_infinite] rounded-full bg-[#186cb2]" />
                </div>
                <p className="mt-2 text-xs font-medium text-white/65">
                    Please wait while the file is being opened
                </p>
                <style>{`
                    @keyframes viewFile {
                        0%, 100% {
                            transform: scale(1);
                            opacity: 0.75;
                        }
                        50% {
                            transform: scale(1.08);
                            opacity: 1;
                        }
                    }
                    @keyframes viewDot {
                        0%, 60%, 100% {
                            opacity: 0.25;
                            transform: translateY(0);
                        }
                        30% {
                            opacity: 1;
                            transform: translateY(-3px);
                        }
                    }
                `}</style>
            </div>
        </div>
    );
}